var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "api-layer" }, [
    _c("fieldset", [
      _c("legend", [_vm._v("RoomCall")]),
      _c(
        "div",
        {
          staticClass: "api-box inline",
          class: { inline: !_vm.callInfo.desc },
        },
        [
          _c("label", { staticClass: "api-title" }, [_vm._v("info")]),
          _vm._v(" roomId:"),
          _c("input", { attrs: { type: "text", name: "roomId" } }),
          _c("button", { on: { click: _vm.getRoomCallInfo } }, [_vm._v("OK")]),
          !!_vm.callInfo.desc
            ? _c("div", [_c("pre", [_vm._v(_vm._s(_vm.callInfo.desc))])])
            : _vm._e(),
        ]
      ),
      _c("div", { staticClass: "api-box" }, [
        _c("label", { staticClass: "api-title" }, [_vm._v("change callType")]),
        _vm._v(" roomId:"),
        _c("input", { attrs: { type: "text", name: "roomId" } }),
        _vm._v("   "),
        _c(
          "select",
          { attrs: { name: "callType" } },
          _vm._l(["p2p", "mixing", "mixer-sfu"], function (callType) {
            return _c(
              "option",
              { key: callType, domProps: { value: callType } },
              [_vm._v(_vm._s(callType))]
            )
          }),
          0
        ),
        _c("button", { on: { click: _vm.changeCallType } }, [_vm._v("OK")]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }